export default __webpack_public_path__ + "static/media/logoTW.c550626a.png";